import React from 'react';
import FilterComponent from '../common/FilterComponent';
import { getFilteredList } from '../utils/Utils';

const CollectionFIlter = ({ list, handleChange, initialFIlters }) => {
  const handleObjChange = (filterObject) => {
    const temp = [];
    const final = [];
    filterObject?.departments?.forEach((item) => {
      list?.forEach((collection) => {
        collection?.categories?.forEach((category) => {
          if (category.name === item) {
            const check = temp.some((e) => e.id === collection.id);
            if (!check) {
              temp.push(collection);
            }
          }
        });
      });
    });
    filterObject?.expertiseLevel?.forEach((item) => {
      temp?.forEach((collection) => {
        if (collection?.expertiseLevel.name === item) {
          const check = final.some((e) => e.id === collection.id);
          if (!check) {
            final.push(collection);
          }
        }
      });
    });
    final?.sort((a, b) => b.id - a.id);
    let filteredArray = final;
    if (filterObject?.searchTerm !== '') {
      filteredArray = getFilteredList(final, filterObject?.searchTerm, ['title', 'id']);
    }
    handleChange([...filteredArray]);
  };
  return <FilterComponent handleObjChange={handleObjChange} filter={initialFIlters} type="Collections" />;
};

export default CollectionFIlter;
